import { inject, Injectable } from '@angular/core';
import type { NotificationMessage } from '@/core/notification/notification-message.model';
import { OPPORTUNITY_LEFT_PENDING_STATUS } from '@/core/notification/notification-message.model';
import { RealtimeNotificationStore } from '@/features/realtime-notification-store.service';

@Injectable({ providedIn: 'root' })
export class PushNotificationDispatcher {
  private readonly realtimeNotificationStore = inject(RealtimeNotificationStore);

  dispatch(raw: unknown): void {
    try {
      const message = parseNotificationMessage(raw);
      this.realtimeNotificationStore.handleOpportunityLeftPendingStatus(message);
    } catch (e) {
      console.error('Failed to parse notification message', e);
    }
  }
}

const parseNotificationMessage = (raw: unknown): NotificationMessage => {
  if (typeof raw === 'string') {
    const payload = JSON.parse(raw) as Partial<NotificationMessage>;
    if (
      payload.type === OPPORTUNITY_LEFT_PENDING_STATUS &&
      typeof payload.opportunityId === 'string' &&
      typeof payload.legalName === 'string' &&
      payload.legalName.length > 0 &&
      typeof payload.status === 'string'
    ) {
      return {
        type: OPPORTUNITY_LEFT_PENDING_STATUS,
        opportunityId: payload.opportunityId,
        legalName: payload.legalName,
        status: payload.status,
      };
    }
  }
  throw new Error('Invalid notification message');
};
